function generateMessageStart(error) {
    if (!!error && !!error.response && !!error.response.status) {
        return 'ERROR (' + error.response.status + '): ';
    } else {
        return 'ERROR: ';
    }
}

function generateMessageBody(error, genericMessage) {
    if (!!error && !!error.response && !!error.response.data && !!error.response.data.message) {
        return error.response.data.message;
    } else {
        return genericMessage;
    }
}

export function handlePresellError(alert, error, genericMessage) {
    let messageBody = generateMessageStart(error) + generateMessageBody(error, genericMessage);

    alert.error(messageBody);
    console.log(messageBody);

    if (!!error && !!error.response && !!error.response.data && !!error.response.data.context) {
        console.log({ context: error.response.data.context });
    }
}
